// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f9d3e78a","453":"67287cae"}[chunkId] + ".chunk.js";
};